import { render, staticRenderFns } from "./PatentStateTab.vue?vue&type=template&id=5c50a595"
import script from "./PatentStateTab.vue?vue&type=script&lang=js"
export * from "./PatentStateTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports